<template>
    <div class="body">
        <div class="title">
            <span class="tab active">党建管理</span>
            <span class="tab" @click="dangyuanguanli">党员管理</span>
            <!-- 面包屑导航区域 -->
            <div class="fansk">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/shouye' }" class="dsadf">
                        <span class="dsadf">首页</span>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>党建管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <div class="btnsearch">
            <div class="left">
                <el-button type="primary" icon="el-icon-plus" size="medium" @click="fabuhuodongguanli" v-if="type === 2">发布</el-button>
            </div>
            <div class="csass"></div>
            <div class="right">
                <el-form :inline="true">
                    <!-- <el-form-item>
                        <el-select placeholder="会员状态" v-model="Query.is_status" @change="Discountsearch" style="min-width: 168px;width: 168px" clearable>
                            <el-option name="selected" :value="0" label="全部 "></el-option>
                            <el-option name="selected" :value="1" label="下架 "></el-option>
                            <el-option name="selected" :value="2" label="上架 "></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-date-picker type="date" value-format="yyyy-MM-dd" @change="Discountsearch" v-model="Query.create_date" placeholder="发布日期">
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-select placeholder="党建类型" v-model="Query.space" @change="Discountsearch" style="min-width: 168px; width: 168px" clearable>
                            <el-option v-for="item in optiontype" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-select placeholder="党建状态" v-model="Query.act_status" @change="Discountsearch" style="min-width: 168px; width: 168px" clearable>
                            <el-option v-for="item in act_status" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="排序/跳转链接/链接说明 " v-model="Query.keyword" @input="Discountsearch" style="min-width: 168px; width: 336px">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <vxe-table border show-overflow keep-source ref="xTable" max-height="750" class="mytable-scrollbar" :data="tableData" align="center" :edit-config="{
        trigger: 'click',
        mode: 'cell',
        icon: 'fa fa-pencil',
        showStatus: true,
      }">
            <vxe-table-column type="seq" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="党建标题" width="100"></vxe-table-column>
            <vxe-table-column field="space" title="党建类型" width="100">
                <template slot-scope="scope">
                    {{ $returnItemValue(typeList, scope.row.space) }}
                </template>
            </vxe-table-column>
            <vxe-table-column field="group_list" title="党建分组" width="150">
                <template slot-scope="scope">
                    {{ getGroupName(scope.row.group_list) }}
                </template>
            </vxe-table-column>

            <!-- <vxe-table-column
        field="enroll_fee"
        title="报名费用"
        width="100"
      ></vxe-table-column> -->
            <vxe-table-column field="address" title="党建地点" width="200">
            </vxe-table-column>
            <!-- town_name -->
            <vxe-table-column field="huodongshijian" title="党建时间" width="300">
                <template slot-scope="scope">
                    {{ scope.row.act_starttime }}-{{ scope.row.act_endtime }}
                </template>
            </vxe-table-column>
            <vxe-table-column field="createtime" title="发布时间" width="200"></vxe-table-column>
            <vxe-table-column field="enrollnum" title="报名人数" width="100"></vxe-table-column>
            <vxe-table-column field="huodongzhuangtai" title="党建状态" width="150">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.act_status === 1">{{ scope.row.act_status_text }}</el-tag>
                    <el-tag type="warning" v-else-if="scope.row.act_status === 0">{{ scope.row.act_status_text }}</el-tag>
                    <el-tag type="warning" v-else-if="scope.row.act_status === 2">{{ scope.row.act_status_text }}
                    </el-tag>
                    <el-tag type="warning" v-else-if="scope.row.act_status === 5">{{ scope.row.act_status_text }}
                    </el-tag>
                    <el-tag type="danger" v-else-if="scope.row.act_status === 3">{{ scope.row.act_status_text }}
                    </el-tag>
                    <el-tag type="danger" v-else-if="scope.row.act_status === 4">{{ scope.row.act_status_text }}
                    </el-tag>
                </template>
            </vxe-table-column>
            <vxe-table-column field="huodongzhuangtai" title="党建审核状态" width="150">
                <template slot-scope="scope">
                    <el-tag type="danger" v-if="scope.row.is_status === 1">未通过</el-tag>
                    <el-tag type="success" v-else-if="scope.row.is_status === 2">审核通过</el-tag>
                    <el-tag type="warning" v-else-if="scope.row.is_status === 3">审核中
                    </el-tag>
                    <el-tag type="danger" v-if="scope.row.is_status === 4">未通过</el-tag>
                </template>
            </vxe-table-column>
            <vxe-table-column title="操作" fixed="right" :min-width="type !== 2 ? 700 : 550">
                <template slot-scope="scope">
                    <!-- 修改按钮 -->
                    <button size="mini" @click="chakanxiangqing(scope.row)" class="bianji">
                        查看详情
                    </button>
                    <!-- <button size="mini" @click="chengjiguanli(scope.row)" class="bianji">
                        成绩管理
                    </button>
                    <button size="mini" @click="baomingjilu(scope.row)" class="bianji">
                        报名记录
                    </button>
                    <button size="mini" @click="xiaochengxuma(scope.row)" class="bianji">
                        小程序码
                    </button>
                    <button size="mini" v-if="scope.row.signin_type.indexOf('2') > -1" @click="xiaochengxuqiandaoma(scope.row)" class="bianji">
                        签到码
                    </button> -->
                    <button v-if="scope.row.is_status === 3 && type !== 2" size="mini" @click="shenhetongguo(scope.row)" class="bianji">
                        审核通过
                    </button>
                    <button v-if="scope.row.is_status === 3 && type !== 2" size="mini" @click="shenhebutongguo(scope.row)" class="bianji red" type="danger">
                        审核不通过
                    </button>
                    <button size="mini" @click="shanchu(scope.row)" class="bianji">
                        删除
                    </button>
                </template>
            </vxe-table-column>
        </vxe-table>
        <div v-if="pageshow">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <Chengjiguanli ref="Chengjiguanli" />
        <Baomingjilu ref="Baomingjilu" />
        <Xiaochengxuma ref="Xiaochengxuma" />
        <XiaochengxuQiandaoma ref="XiaochengxuQiandaoma" />
    </div>
</template>

<script>
    import Chengjiguanli from "./components/Chengjiguanli";
    import Baomingjilu from "./components/Baomingjilu";
    import Xiaochengxuma from "./components/Xiaochengxuma";
    import XiaochengxuQiandaoma from "./components/XiaochengxuQiandaoma";

    import {
        actPartyBuildingList,
        actPartyBuildingDelete
    } from "@/api/dangjianguanli";

    import {
        huoDongSetstatusval,
    } from "@/api/tiezi";

    import { adminInfo } from "@/api/login";

    export default {
        name: "index",
        components: { Chengjiguanli, Baomingjilu, Xiaochengxuma, XiaochengxuQiandaoma },
        data() {
            return {
                type: 2,
                tableData: [],
                Query: {
                    token: sessionStorage.getItem("token"),
                    create_date: "",
                    space: "",
                    act_status: null,
                    keyword: "",
                    page: 1,
                    pagesize: 10,
                    is_status: 0,
                },
                total: null,
                pageshow: true,
                cur_page: 1,
                typeList: [{
                    label: "跑步",
                    value: '1',
                }, {
                    label: "篮球",
                    value: '2',
                }, {
                    label: "羽毛球",
                    value: '3',
                }, {
                    label: "乒乓球",
                    value: '4',
                }, {
                    label: "足球",
                    value: '5',
                }, {
                    label: "游泳",
                    value: '6',
                }, {
                    label: "篮球",
                    value: '7',
                }, {
                    label: "党建活动",
                    value: "10",
                }, {
                    label: "马拉松",
                    value: "11",
                }, {
                    label: "其他",
                    value: '8',
                }, ],
                act_status: [{
                    label: "全部",
                    value: "",
                }, {
                    label: "报名未开始",
                    value: "0",
                }, {
                    label: "报名进行中",
                    value: "1",
                }, {
                    label: "报名已结束",
                    value: "2",
                }, {
                    label: "活动已报满",
                    value: "3",
                }, {
                    label: "活动进行中",
                    value: "4",
                }, {
                    label: "活动已结束",
                    value: "5",
                }, ],
            };
        },
        created() {
            this.getUserInfo();
            this.xiangqing();
        },
        methods: {
            getUserInfo() {
                const obj = {
                    token: sessionStorage.getItem("token"),
                };
                adminInfo(obj).then(({ data: res }) => {
                    console.log("res", res);
                    this.type = res.type;
                });
            },
            shanchu(item) {
                this.$confirm("确认删除吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                    })
                    .then(() => {
                        const obj = {
                            token: sessionStorage.getItem("token"),
                            id: item.id,
                        };
                        actPartyBuildingDelete(obj).then(({ data: res }) => {
                            console.log("res", res);
                            if (res.result === -1) {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                });
                                setTimeout(() => {
                                    window.sessionStorage.clear();
                                    this.$router.push("/login");
                                }, 1000);
                            }
                            if (res.result === 0) {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                });
                                return false;
                            }
                            if (res.result === 1) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success",
                                    duration: "2000",
                                });
                                this.xiangqing();
                            }
                        });
                    })
                    .catch(() => {});
            },
            Discountsearch() {
                this.cur_page = 1;
                this.xiangqing();
                this.pageshow = false; // 让分页隐藏
                this.$nextTick(() => {
                    // 重新渲染分页
                    this.pageshow = true;
                });
            },
            handleSizeChange(val) {
                this.Query.pagesize = val;
                this.handleCurrentChange(this.Query.page);
            },
            handleCurrentChange(val) {
                this.Query.page = val;
                actPartyBuildingList(this.Query).then(({ data: res }) => {
                    console.log("res", res);
                    this.tableData = res.list;
                    this.total = res.total;
                    this.tableData.forEach((i) => {
                        i.address = i.area_name + i.town_name || '';
                        i.huodongshijian = i.act_starttime + "---" + i.act_endtime;
                    });
                });
            },
            xiangqing() {
                actPartyBuildingList(this.Query).then(({ data: res }) => {
                    console.log("res", res);
                    this.tableData = res.list;
                    this.total = res.total;
                    this.tableData.forEach((i) => {
                        i.address = i.area_name + i.town_name || '';
                        i.huodongshijian = i.act_starttime + i.act_endtime;
                    });
                });
            },
            dangyuanguanli() {
                this.$router.push("/dangyuanguanli");
            },
            fabuhuodongguanli() {
                this.$router.push("/fabudangjianguanli");
            },
            chakanxiangqing(row) {
                // this.$store.commit("sethuodongID", row.id);
                this.$router.push("/xiangqingdangjianguanli?id=" + row.id);
            },
            chengjiguanli(row) {
                this.$refs.Chengjiguanli.handleOpenDialog(row)
            },
            baomingjilu(row) {
                this.$refs.Baomingjilu.handleOpenDialog(row)
            },
            xiaochengxuma(row) {
                this.$refs.Xiaochengxuma.handleOpenDialog(row)
            },
            xiaochengxuqiandaoma(row) {
                this.$refs.XiaochengxuQiandaoma.handleOpenDialog(row)
            },
            shenhetongguo(row) {
                this.$confirm("确认审核通过这条党建吗?", "审核通过", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                    })
                    .then(() => {
                        huoDongSetstatusval({
                            token: sessionStorage.getItem("token"),
                            id: row.id,
                            is_status: 2,
                        }).then(({ data: res }) => {});
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.xiangqing();
                    })
                    .catch(() => {});
            },
            shenhebutongguo(row) {
                this.$confirm("确认审核不通过这条党建吗?", "审核不通过", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                    })
                    .then(() => {
                        huoDongSetstatusval({
                            token: sessionStorage.getItem("token"),
                            id: row.id,
                            is_status: 4,
                        }).then(({ data: res }) => {});
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.xiangqing();
                    })
                    .catch(() => {});
            },

            getGroupName(list) {
                return list.map(item => item.title).join(',');
            }
        },
    };
</script>

<style scoped lang="less">
    .bianji {
        width: 78px;
        height: 37px;
        opacity: 1;
        border: 1px solid rgba(61, 154, 255, 0.5);
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #3d9aff;
        letter-spacing: 0px;
        background: white;
        margin-right: 10px;

        &.red {
            color: #f56c6c;
            border-color: #f56c6c;
        }
    }

    .body {
        display: flex;
        flex-direction: column;

        .title {
            opacity: 1;
            font-size: 30px;
            font-family: PingFang SC, PingFang SC-Heavy;
            font-weight: 800;
            text-align: left;
            color: #2e2e2e;
            letter-spacing: 0px;
            margin-bottom: 35px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .tab {
                margin-right: 20px;
                color: #999;
                cursor: pointer;

                &.active {
                    color: #2e2e2e;
                    cursor: default;

                    &:hover {
                        text-decoration: none;
                    }
                }

                &:hover {
                    color: #2e2e2e;
                    text-decoration: underline;
                }
            }

            .fansk {
                margin-top: 30px;
                margin-left: 32px;
            }

            .dsadf {
                color: #3d9aff;
            }
        }

        .btnsearch {
            display: flex;
            flex-direction: row;
            align-items: center;

            .left {
                margin-right: 150px;
            }

            .right {
                margin-top: 27px;
            }
        }
    }
</style>